import React from "react";

const Bar = ({ label, value, target, unit, accent }) => {
  const pct = target ? Math.min(100, Math.round((value / target) * 100)) : 0;
  const over = target && value > target;
  return (
    <div>
      <div className="flex items-baseline justify-between mb-1">
        <span className="overline">{label}</span>
        <span className="font-data text-xs text-zinc-400">
          <span className={over ? "text-red-400" : "text-white"}>{Math.round(value)}</span>
          {target ? ` / ${Math.round(target)}` : ""} {unit}
        </span>
      </div>
      <div className="h-1.5 bg-obsidian-600/60 rounded-sm overflow-hidden">
        <div
          className={`h-full transition-all ${over ? "bg-red-500" : accent}`}
          style={{ width: `${target ? pct : 0}%` }}
        />
      </div>
    </div>
  );
};

export const MacroBars = ({ totals, targets }) => (
  <div className="obs-card" data-testid="food-macro-bars">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Bar label="Calories" value={totals?.calories || 0} target={targets?.calories} unit="kcal" accent="bg-blaze" />
      <Bar label="Protein" value={totals?.protein_g || 0} target={targets?.protein_g} unit="g" accent="bg-emerald-500" />
      <Bar label="Carbs" value={totals?.carbs_g || 0} target={targets?.carbs_g} unit="g" accent="bg-sky-500" />
      <Bar label="Fat" value={totals?.fat_g || 0} target={targets?.fat_g} unit="g" accent="bg-amber-500" />
    </div>
    {!targets && (
      <p className="text-xs text-zinc-500 mt-3">No macro targets yet — complete onboarding or run the macro calculator.</p>
    )}
  </div>
);

export default MacroBars;
